import React, {useState, useEffect} from 'react'
import PropTypes from 'prop-types'
import * as Parser from 'rss-parser';
import RelatedRow from './relatedrow'
import relatedsectionStyles from '../../styles/modules/relatedsection.module.less'

const requestfeed = async (url, setFunc) => {
    let parser = new Parser({
      // image stuff doesn't come in on it's own
      customFields: {
        item: [
          ['media:content', 'media:content'],
        ]
      }
    });
    let feed = await parser.parseURL(url);
    let newLinks = []
    for(let i=0; (i < feed.items.length && i < 3); i++){
        let url = 'https://s.hdnux.com/photos/01/15/55/75/20373375/6/premium_gallery_landscape.jpg' // generic image for if a story has no image
        try {
            url = feed.items[i]['media:content']['$'].url
            url = url.replace('rawImage', 'premium_gallery_landscape')
        } catch(err){
            err = '' // do nothing if no image is found
        }
        
        newLinks.push({
            title: feed.items[i].title,
            url: feed.items[i].link,
            pubdate: feed.items[i].pubDate
        })
    }
    setFunc(newLinks, 'links')
}

const LatestFeed = ({ feed }) => {
    let [links, setLinks] = useState([])
    
    useEffect(()=>{ 
        requestfeed(feed, setLinks)
    }, [])
    
    // implement 
    return (
        <div className={"container " + relatedsectionStyles.section}>
            <h4 className={relatedsectionStyles.hed}>Latest news</h4>
            <RelatedRow links={links} />
        </div>
    )
}

LatestFeed.propTypes = {
  feed: PropTypes.string.isRequired,
}

export default LatestFeed
